import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var SizeGuideHeader = styled.div.withConfig({
  displayName: "SizeGuideHeader",
  componentId: "sc-1177um7-0"
})(["align-items:flex-start;display:flex;flex-flow:column wrap;justify-content:space-between;margin-bottom:", ";", ""], rem(16), media.xs(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        align-items: center;\n        flex-flow: row wrap;\n    "]))));
export default SizeGuideHeader;